import React from 'react';

import useCheckoutState from '../../hooks/useCheckoutState';
import clsx from 'clsx';

const PaymentOptions = () => {
  const { checkout, paymentOption, setPaymentOption, setSelectedPaymentMethod } =
    useCheckoutState();

  const enabledOptions = checkout.paymentOptions?.filter(option => option.enabled);

  const hasNoPaymentOptions = enabledOptions.length === 0;
  const isOnlyFullPayment = enabledOptions.length === 1 && enabledOptions[0].type === 'full';

  if (hasNoPaymentOptions || isOnlyFullPayment) {
    return null;
  }

  const visibleOptions = enabledOptions.filter(option => option.showPaymentButton);

  return (
    <div className="cp_payment-options-wrapper">
      {visibleOptions.length > 0 && (
        <div className="cp_payment-options-container flex flex-row gap-2 mb-2">
          {visibleOptions.map(option => {
            const isSelected = paymentOption.type === option.type;

            return (
              <button
                key={option.type}
                type="button"
                onClick={() => {
                  setPaymentOption(option);

                  if (option.type === 'manual') {
                    setSelectedPaymentMethod('manual');
                  } else {
                    setSelectedPaymentMethod('card');
                  }
                }}
                className={clsx(
                  `cp_payment-option cp_payment-option--${option.type}`,
                  'bg-white border focus:outline-none rounded w-full p-2 flex flex-col',
                  {
                    'border-gray-200 !bg-[var(--payment-option-background-color)]': !isSelected,
                    'cp_payment-option--selected z-10 ring-1 ring-[var(--payment-option-selected-border-color)] !border-[var(--payment-option-selected-border-color)] !bg-[var(--payment-option-selected-background-color)]':
                      isSelected,
                  },
                )}
              >
                <div className="cp_payment-option-content text-left flex flex-col h-full">
                  <div className="cp_payment-option-name font-semibold">{option.name}</div>
                  <div className="cp_payment-option-description text-sm text-gray-600">
                    {option.description}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}

      {paymentOption.instructions && (
        <div className="cp_payment-option-instructions-wrapper">
          <div className="cp_payment-option-instructions text-sm text-gray-600">
            {paymentOption.instructions}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;
